import { useState } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'

const UpdateAnnouncementModal = ({ announcement, onClose, onView, onActionClick }) => {
  const [isClosing, setIsClosing] = useState(false)

  const handleClose = async () => {
    setIsClosing(true)
    await onView()
    setTimeout(() => {
      onClose()
    }, 200)
  }

  const handleActionClick = async () => {
    await onActionClick()
    if (announcement.actionButton?.link) {
      if (announcement.actionButton.link.startsWith('http')) {
        window.open(announcement.actionButton.link, '_blank')
      } else {
        window.location.href = announcement.actionButton.link
      }
    }
    handleClose()
  }

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
      <div
        className={`bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] shadow-2xl transform transition-all duration-200 overflow-hidden flex flex-col ${
          isClosing ? 'scale-95 opacity-0' : 'scale-100 opacity-100'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <h2 className="text-2xl font-bold text-slate-900">{announcement.title}</h2>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
          >
            <XMarkIcon className="w-6 h-6 text-slate-400" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1">
          {announcement.imageUrl && (
            <div className="mb-6 rounded-xl overflow-hidden">
              <img
                src={announcement.imageUrl}
                alt={announcement.title}
                className="w-full h-auto object-cover max-h-96"
              />
            </div>
          )}

          <div className="prose prose-slate max-w-none">
            <p className="text-slate-700 whitespace-pre-wrap">{announcement.content}</p>
          </div>
        </div>

        {/* Actions - Fixed at bottom */}
        <div className="p-6 border-t border-slate-200 bg-white">
          <div className="flex items-center gap-3">
            {announcement.actionButton && (
              <button
                onClick={handleActionClick}
                className="flex-1 bg-brand-lime hover:bg-brand-lime-600 text-brand-black font-bold py-3 rounded-xl transition-all shadow-md hover:shadow-lg"
              >
                {announcement.actionButton.text}
              </button>
            )}
            <button
              onClick={handleClose}
              className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold py-3 rounded-xl transition-all"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateAnnouncementModal
